module.exports = __webpack_public_path__ + "img/abs_3.466b5eda.jpeg";